import React from "react";

const LatestNews = () => {
  return (
    <div className="px-1">
      <h1 className="home-title">Here's the latest happenings in Pixels!</h1>

      <div className="flex flex-col md:flex-row gap-3 md:gap-4">
        {/* This Month Section */}
        <div className="home-section flex-1">
          <h3 className="home-h3 text-lg md:text-xl font-bold mb-3 border-b pb-2">🎉 Happening This Month [Jul 2026]</h3>
          <div className="home-body space-y-3">
            <a
              href="https://pixelspost.substack.com/p/new-event-cagy-lost-his-silly-kitties"
              rel="noreferrer"
              target="_blank"
              className="block hover:text-[var(--link-hover-color)]"
            >
              🐈 Cagy's Silly Kitties
            </a>
          </div>
        </div>

        {/* Previous Happenings Section - Scrollable */}
        <div className="home-section flex-1">
          <h3 className="home-h3 text-lg md:text-xl font-bold mb-3 border-b pb-2">📜 Previous Happenings</h3>

          {/* Fixed height scrollable container */}
          <div className="h-64 overflow-y-auto pr-2 space-y-4 custom-scrollbar">
            {/* June 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">JUNE 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-3">
                 <a
                  href="https://pixelspost.substack.com/p/pixels-community-cup-tomorrow-and"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  🏆 Pixels Community Cup
                </a>
                 <a
                  href="https://pixelspost.substack.com/p/shorelimes-are-back-for-24h"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  🍋‍🟩24 Hour Shorelime Event
                </a>
                <a
                  href="https://pixelspost.substack.com/p/new-easter-event-rift-of-the-rabbits"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  🎮 Neon Zone Arcade Refresh. Wheel is back!
                </a>
                <a
                  href="https://pixelspost.substack.com/p/a-huge-vip-update-is-here"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  1️⃣ VIP Update - Tiers 1 - 6, new perks (energy surplus!), and more!
                </a>
              </div>
            </div>

            {/* May 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">MAY 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/new-event-lily-of-the-valley"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  🌸 New Event: Lily of the Valley
                </a>
                <a
                  href="https://pixelspost.substack.com/p/new-event-into-the-bobverse-the-search"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  👻Bob's Birthday and the search for Bob
                </a>
              </div>
            </div>

            {/* APR 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">APR 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/new-easter-event-rift-of-the-rabbits"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  🐰 Easter Event: Rift of the Rabbits
                </a>
                <a
                  href="https://pixelspost.substack.com/p/huge-update-tier-5-is-here"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)]"
                >
                  5️⃣ Tier 5 Released!
                </a>
              </div>
            </div>

            {/* MAR 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">MAR 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/meet-stacked-the-app-that-makes-play"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  📤 STACKED RELEASE
                </a>
                <a
                  href="https://pixelspost.substack.com/p/new-event-shameus-shameful-st-patricks"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🍀 St. Patrick's Celebration
                </a>
              </div>
            </div>

            {/* FEB 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">FEB 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/new-quest-choco-lot-of-love"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  💖 Choco-Lot of Love February Valentine's Quest
                </a>
              </div>
            </div>

            {/* JAN 2026 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">JAN 2026</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/huge-update-animal-care-quests-more"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🐔 Animal Care Massive Update
                </a>
                <a
                  href="https://pixelspost.substack.com/p/new-event-terra-villa-creator-crumb"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🍪 Terra Villa Creator Crumb-Trail weeks-long quest
                </a>
              </div>
            </div>

            {/* DEC 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">DEC 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/nft-pets-just-got-an-upgrade"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🐕 Pet Updates
                </a>
                <a
                  href="https://pixelspost.substack.com/p/first-ever-creator-ama-2025-recap"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🛂 Content Creator AMA
                </a>
                <a
                  href="https://pixelspost.substack.com/p/pixmas-is-here-new-holiday-quest"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🎄 Pixmas in Terra Villa
                </a>
              </div>
            </div>

            {/* OCT 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">OCT 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/new-neon-zone-game-living-labyrinth"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🎃 New Halloween Game Mode in LNZ & Halloween Quest
                </a>
                <a
                  href="https://pixelspost.substack.com/p/welcome-to-chapter-3-bountyfall"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  📖 Chapter 3 Released!
                </a>
                <a
                  href="https://pixelspost.substack.com/p/new-game-alert-mines-dropping-in"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🎮 New Mini-game in Leon's Neon Zone (Mines)
                </a>
                <a
                  href="https://pixelspost.substack.com/p/merchant-ships-just-got-a-big-update"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🐠 Merchant Fleet Update with Fishing & Sushi
                </a>
              </div>
            </div>

            {/* SEPT 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">SEPT 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <div className="text-sm">🎟️ VIP Tiering adjustments</div>
                <div className="text-sm">⚡ New Energy Drink on the Market</div>
                <div className="text-sm">🎵 Terra Beats Music Festival</div>
                <div className="text-sm">🎮 Texas Hold'em Poker added to LNZ</div>
              </div>
            </div>

            {/* AUG 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">AUG 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <div className="text-sm">🐝 Save the Bees Quest</div>
                <a
                  href="https://pixelspost.substack.com/p/welcome-to-leons-neon-zone-terra"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🎮 Leon's Neon Zone & Forestry Updates
                </a>
              </div>
            </div>

            {/* JULY 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">JULY 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <div className="text-sm">❗ Surplus increased to 8-12% for Land Owners</div>
                <a
                  href="https://pixelspost.substack.com/p/step-right-up-to-the-first-ever-ugc"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🪓 Crafting surplus & Farm Charm Points repurposed
                </a>
                <a
                  href="https://pixelspost.substack.com/p/step-right-up-to-the-first-ever-ugc"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  👻 The UGC Fair goes live
                </a>
                <div className="text-sm">🧲 New Grassland Ore and Crop added</div>
                <div className="text-sm">🎚️ VIP Tiering added to the game</div>
              </div>
            </div>

            {/* JUNE 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">JUNE 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/pixels-x-sleepagotchi-a-new-game"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  💤 Sleepagotchi Joins the Pixelsverse
                </a>
                <div className="text-sm">🌳 Trees NFT Trait Limits update</div>
                <div className="text-sm">💰 90M $PIXEL staked in ecosystem</div>
              </div>
            </div>

            {/* MAY 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">MAY 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <div className="text-sm">🌱 Soils can now be harvested by anyone</div>
                <a
                  href="https://pixelspost.substack.com/p/a-new-castle-has-appeared-in-terra"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🤖 AIVeronica collab in-game
                </a>
                <div className="text-sm">🚢 Merchant Ship Seaside Stash Update</div>
                <div className="text-sm">🍳 Cooking made tradable again</div>
                <a
                  href="https://pixelspost.substack.com/p/pixel-staking-has-arrived"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  💎 $PIXEL Staking is finally live!
                </a>
              </div>
            </div>

            {/* APRIL 2025 */}
            <div className="month-group">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🗓️</span>
                <div className="text-left font-bold text-md uppercase tracking-wide">APRIL 2025</div>
                <div className="flex-1 h-px bg-gradient-to-r from-gray-400 to-transparent"></div>
              </div>
              <div className="home-body space-y-2 pl-3 border-l-2 border-gray-300 ml-1">
                <a
                  href="https://pixelspost.substack.com/p/sophias-egg-hunt-is-on"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🐰 Easter Egg Hunt
                </a>
                <a
                  href="https://pixelspost.substack.com/p/welcome-to-port-the-merchant-fleet"
                  rel="noreferrer"
                  target="_blank"
                  className="block hover:text-[var(--link-hover-color)] text-sm transition-colors"
                >
                  🚢 Merchant Fleet released
                </a>
                <div className="text-sm">💠 Pixels x Runiverse Collaboration announced</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-sm mt-2">
        Want to write an article or collaborate on something?{" "}
        <a href="mailto:P1XELORE@proton.me" className="wiki-links">
          Send me an email! 💖
        </a>
      </div>
    </div>
  );
};

export default LatestNews;
